import ResellerProvider from "../ResellerProvider";

export default function Provider(props) {
    return (
        <ResellerProvider>
            {props.children}
        </ResellerProvider>
    )
}
